import { render, staticRenderFns } from "./commentWarning.vue?vue&type=template&id=0524c198&scoped=true"
import script from "./commentWarning.vue?vue&type=script&lang=js"
export * from "./commentWarning.vue?vue&type=script&lang=js"
import style0 from "./commentWarning.vue?vue&type=style&index=0&id=0524c198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524c198",
  null
  
)

export default component.exports